import React, { Component, Fragment } from 'react';
import { Fade, Zoom } from 'react-reveal';
import { Col, Container, Row } from 'shards-react';
import { ReactComponent as Contact } from '../../../assets/img/homepage/contact.svg';
import { ReactComponent as Forms } from '../../../assets/img/homepage/form.svg';
import { ReactComponent as Progress } from '../../../assets/img/homepage/progress2.svg';
import { ReactComponent as LandingImage } from '../../../assets/img/typing.svg';
import LandingNavbar from '../../layout/Navbar/LandingNavbar';
import ContactForm from '../ContactPage/ContactForm';
import '../Landing/Landing.scss';

class ErrorPage extends Component {
  state = {
    navbarOpen: false,
  };
  handleNavbar = () => {
    this.setState({ navbarOpen: !this.state.navbarOpen });
  };
  render() {
    return (
      <Fragment>
        <Container className=''>
          <Row className='align-items-center text-white h-100'>
            <Col className='align-items-center' sm='12' lg='6'>
              <img
                className='d-flex w-100'
                src='https://firebasestorage.googleapis.com/v0/b/ncccaduan.appspot.com/o/assets%2Fundraw_bug_fixing_oc7a%20(1).svg?alt=media&token=fbfeb28b-21fb-4a75-a99b-f824b98a1191'
              />
            </Col>
            <Col
              className='align-items-center text-center errorContainer bg-secondary h-100'
              sm='12'
              lg='6'
            >
              <h1 className='text-white p-2 m-2'>We'll be back soon!</h1>
              <h4 className='text-white p-3 m-2'>
                Due the Restricted Movement as announced by the Prime Minister
                of Malaysia, NCCC will not be able to receive or process any
                complaints until further notice. Sorry for the inconvenience.
                <br /> <br></br> We will resume our normal operation after the
                lockdown period. <br></br>
                <br></br>
                NCCC Team
              </h4>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default ErrorPage;
